document.addEventListener("DOMContentLoaded", function () {
  // Function to toggle menu
  function toggleMenu(toggleButton, targetMenu) {
    const isExpanded = toggleButton.getAttribute("aria-expanded") === "true";

    toggleButton.setAttribute("aria-expanded", !isExpanded);
    if (!isExpanded) {
      targetMenu.style.maxHeight = targetMenu.scrollHeight + "px";
      targetMenu.classList.add("expanded");
      toggleButton.classList.add("expanded");
    } else {
      targetMenu.style.maxHeight = "0";
      targetMenu.classList.remove("expanded");
      toggleButton.classList.remove("expanded");
    }
  }

  // Make entire header div clickable
  const menuHeaders = document.querySelectorAll(".footer__menu-header");
  menuHeaders.forEach((header) => {
    header.addEventListener("click", function (e) {
      // Only on mobile
      if (window.innerWidth > 768) return;

      const targetId = this.getAttribute("data-toggle-target");
      const targetMenu = document.getElementById(targetId);
      const toggleButton = this.querySelector(".footer__menu-toggle, .footer__social-toggle");

      if (!targetMenu || !toggleButton) {
        console.error("Target menu or toggle button not found:", targetId);
        return;
      }

      toggleMenu(toggleButton, targetMenu);
    });
  });

  // Keep the original button click functionality (for accessibility)
  const menuToggles = document.querySelectorAll(".footer__menu-toggle, .footer__social-toggle");
  menuToggles.forEach((toggle) => {
    toggle.addEventListener("click", function (e) {
      // Prevent double-triggering from parent div click
      e.stopPropagation();

      const targetId = this.getAttribute("aria-controls");
      const targetMenu = document.getElementById(targetId);

      if (!targetMenu) {
        console.error("Target menu not found:", targetId);
        return;
      }

      toggleMenu(this, targetMenu);
    });
  });
});
